import { useEffect, useMemo, useRef, useState } from "react"
import DatabaseDeadlock from "../../../components/Inspectra/DatabaseDeadlock"
import PingAPI from "../../../components/Inspectra/PingAPI"
import ServiceError from "../../../components/Inspectra/ServiceError"
import StreamSet from "../../../components/Inspectra/StreamSet"
import ProceduralError from "../../../components/Inspectra/ProceduralError"
import DriveSpace from "../../../components/Inspectra/DriveSpace.jsx"
import DatabaseSize from "../../../components/Inspectra/DatabaseSize"
import services from "../../../services/services.js"
import MemoryUsage from "../../../components/Inspectra/MemoryUsage.jsx"
import HitsService from "../../../components/Inspectra/HitsService.jsx"
import UptimeTrend from "../../../components/Inspectra/UptimeTrend.jsx"
import { useCommon } from "../../Common/useCommon.js"
import _ from "underscore"
import FailSqlJobs from "../../../components/Inspectra/FailSqlJobs.jsx"
import { encryptData } from "../../../utils/encrypt.js"
import { callautopopulate } from "../../../services/callautopop.js"
import TopCpuQueries from "../../../components/Inspectra/TopCpuQueries.jsx"
import BlockingSession from "../../../components/Inspectra/BlockingSession.jsx"
import CheckBlocking from "../../../components/Inspectra/CheckBlocking.jsx"

export const useInspectraDashboard = () => {

    const { projectOpts, getUserProjects } = useCommon();
    const [projectOptions, setProjectOptions] = useState([]);
    const [hostData, setHostData] = useState([]);
    const [selectedProject, setSelectedProject] = useState({});
    const [callApi, setCallApi] = useState(false);
    const tagRef = useRef(null);
    const [selectedTab, setSelectedTab] = useState("error");
    const [autopopData, setAutopopData] = useState({});
    const [errorWidget] = useState({
        layout: [
            { "w": 15, "h": 11, "x": 0, "y": 0, "i": "0" },
            { "w": 30, "h": 11, "x": 15, "y": 0, "i": "1" },
            { "w": 15, "h": 11, "x": 45, "y": 0, "i": "2" },
            { "w": 15, "h": 11, "x": 0, "y": 11, "i": "3" },
            { "w": 30, "h": 11, "x": 15, "y": 11, "i": "4" },
            { "w": 15, "h": 11, "x": 45, "y": 11, "i": "5" },
        ],
        compo: [{ name: PingAPI }, { name: ServiceError }, { name: DatabaseDeadlock }, { name: StreamSet }, { name: ProceduralError }, { name: FailSqlJobs }]
    })
    const [infoWidget] = useState({
        layout: [
            { "w": 30, "h": 11, "x": 0, "y": 0, "i": "0" },
            { "w": 30, "h": 11, "x": 30, "y": 0, "i": "1" },
            { "w": 60, "h": 11, "x": 0, "y": 11, "i": "2" },
            { "w": 60, "h": 19, "x": 0, "y": 22, "i": "3" },
            { "w": 60, "h": 19, "x": 0, "y": 41, "i": "4" },
            { "w": 60, "h": 15, "x": 0, "y": 60, "i": "5" },
            { "w": 60, "h": 15, "x": 0, "y": 75, "i": "6" },
            { "w": 60, "h": 30, "x": 0, "y": 90, "i": "7" },
        ],
        compo: [{ name: DriveSpace }, { name: DatabaseSize }, { name: MemoryUsage }, { name: HitsService }, { name: UptimeTrend }, { name: TopCpuQueries }, { name: BlockingSession },{ name: CheckBlocking }]
    })
    const widget = selectedTab === "error" ? errorWidget?.compo : infoWidget?.compo;
    const layout = selectedTab === "error" ? errorWidget?.layout : infoWidget?.layout

    useEffect(() => {
        const handleReload = () => {
            sessionStorage.removeItem("inspectra_project");
        }
        window.addEventListener("beforeunload", handleReload);
        return () => {
            sessionStorage.removeItem("inspectra_project");
            window.removeEventListener("beforeunload", handleReload);
        }
    }, [])

    useEffect(() => {
        sessionStorage.removeItem("project_domain_host");
        callautopopulate("project_domain_host").then(res => {
            setHostData(res?.project_domain_host);
        })
        getUserProjects();
    }, [])

    useEffect(() => {
        if (!_.isEmpty(hostData)) {
            projectOptions?.map((item) => {
                hostData?.forEach((host) => {
                    if (host?.project_key === item?.project_key) {
                        item["host"] = [...item["host"] || [], host];
                    }
                })
            })
        }
    }, [hostData, projectOptions])

    useEffect(() => {
        if (!_.isEmpty(projectOpts)) {
            setProjectOptions(projectOpts);
            setSelectedProject(projectOpts?.[0]);
        }
    }, [projectOpts])

    useEffect(() => {
        if (!_.isEmpty(selectedProject)) {
            callAutopopulate();
            sessionStorage.setItem("inspectra_project", encryptData(JSON.stringify(selectedProject)));
            setCallApi(!callApi);
        }
    }, [selectedProject])

    const callAutopopulate = async () => {
        try {
            setAutopopData([]);
            const res = await services?.callInspectra("GET", `/elsinspectra/autopopulate/${selectedProject?.project_key}`, {});
            if (res) {
                const data = res?.data;
                setAutopopData(data);
            }
        } catch (error) {
            console.error("Error in Inspectra autopopulate: ", error);
        }
    }

    return useMemo(() => ({
        widget, layout, autopopData, tagRef, projectOptions, selectedProject, setSelectedProject, callApi, selectedTab, setSelectedTab
    }), [widget, layout, autopopData, tagRef, projectOptions, selectedProject, setSelectedProject, callApi, selectedTab, setSelectedTab])
}